import { Content } from "@prismicio/client";
import React, { useEffect, useState } from "react";
import { useCustomer } from "@middleware/hooks";
import { EFixedBarPosition } from "@middleware/types";
import { getFromStorage } from "@middleware/helpers/global/sessions";
import {
  MODAL_OPENING_DELAY,
  REFERRAL_FORM_SUBMITTED,
  REFERRAL_MODAL,
} from "@middleware/constants";
import ReferralModal from "@components/commun/Modals/ReferralModal/ReferralModal";
import { useTranslation } from "next-i18next";
import FixedBar from "../FixedBar/FixedBar";
import style from "./ReferralBar.module.scss";

interface Props {
  referralBarData?:
    | Content.ReferralPopupDocument
    | Content.ReferralPopupStagingDocument;
  barIsActivated: boolean;
  popupIsActivated: boolean;
}
export default function ReferralBar({
  referralBarData,
  barIsActivated,
  popupIsActivated,
}: Props) {
  const { customer } = useCustomer();
  const [isOpen, setIsOpen] = useState(false);
  const [mailSubmitted, setMailSubmitted] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const init = () => {
      const referralModalStorage = Boolean(getFromStorage(REFERRAL_MODAL));
      const open = referralModalStorage ? false : true;
      if (open) {
        setIsOpen(open);
      }
    };
    const initBarDisplay = () => {
      const referralBarStorage = Boolean(
        getFromStorage(REFERRAL_FORM_SUBMITTED),
      );
      const canShowBar = referralBarStorage ? false : true;
      setMailSubmitted(!canShowBar);
    };
    void initBarDisplay();
    setTimeout(() => {
      void init();
    }, MODAL_OPENING_DELAY);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMailSubmitted = () => {
    setMailSubmitted(true);
  };

  return !mailSubmitted ? (
    <>
      {barIsActivated && popupIsActivated && (
        <FixedBar
          text={referralBarData?.data.fixedBarText}
          button={{
            label: t("buttons.sponsor"),
            click: () => setIsOpen(true),
          }}
          position={EFixedBarPosition.TOP}
          className={style.bar}
          actionClassName={style.action}
          wrapClassName={style.wrap}
        />
      )}
      {customer && popupIsActivated && (
        <ReferralModal
          modalContent={referralBarData}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          customer={customer}
          mailSubmitted={handleMailSubmitted}
        />
      )}
    </>
  ) : null;
}
